/*
 * Mobile nav
 *
 * Based on https://codepen.io/marcysutton/pen/JoQqVw
 */

'use-strict';

import 'wicg-inert';

class MobileNav {
  constructor() {
    this.ESCAPE_CODE = 27;
    this.BREAKPOINT = 'lg';
    this.ACTIVE_CLASS = 'active';

    this.mobileNavOpenButton = document.querySelector('.js-mobile-nav-open');
    this.mobileNavCloseButton = document.querySelector('.js-mobile-nav-close');
    this.mobileNavMenu = document.querySelector('.js-mobile-nav-menu');
    this.mobileNavTriggers = document.querySelectorAll(
      '.js-slidetoggle-trigger'
    );

    let slideUp = (target, duration = 500) => {
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.boxSizing = 'border-box';
      target.style.height = target.offsetHeight + 'px';
      target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      window.setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
      }, duration);
    };

    let slideDown = (target, duration = 500) => {
      target.style.removeProperty('display');
      let display = window.getComputedStyle(target).display;

      if (display === 'none') {
        display = 'block';
      }

      target.style.display = display;
      let height = target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      target.offsetHeight;
      target.style.boxSizing = 'border-box';
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.height = height + 'px';
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);
    };

    var slideToggle = (target, duration = 500) => {
      if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration);
      } else {
        return slideUp(target, duration);
      }
    };

    Array.from(this.mobileNavTriggers).forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        e.currentTarget.classList.toggle('mobile-nav__toggle--open');

        const navTarget = e.currentTarget.parentElement.querySelector(
          '.js-slidetoggle-target'
        );
        slideToggle(navTarget, 200);
      });
    });

    // If user presses the escape key with the nav open
    this.mobileNavMenu.addEventListener(
      'keydown',
      this.handleKeydown.bind(this)
    );
    // If user presses the open button
    this.mobileNavOpenButton.addEventListener(
      'click',
      this.handleOpenButtonClick.bind(this)
    );
    // If user presses the close button
    this.mobileNavCloseButton.addEventListener(
      'click',
      this.handleCloseButtonClick.bind(this)
    );
  }

  // If the user presses the escape key, close the nav and focus on the open button
  handleKeydown(event) {
    if (event.keyCode === this.ESCAPE_CODE) {
      this.mobileNavMenu.inert = true;
      this.mobileNavMenu.classList.remove(this.ACTIVE_CLASS);
      this.mobileNavOpenButton.focus();
    }
  }

  // If the user clicks the open button, open the nav and focus on the close button
  handleOpenButtonClick() {
    this.mobileNavMenu.inert = false;
    this.mobileNavMenu.classList.add(this.ACTIVE_CLASS);
    this.mobileNavOpenButton.classList.add(this.ACTIVE_CLASS);
    this.mobileNavCloseButton.focus();
  }

  // If the user clicks the close button, close the nav and focus on the open button
  handleCloseButtonClick() {
    this.mobileNavMenu.inert = true;
    this.mobileNavMenu.classList.remove(this.ACTIVE_CLASS);
    this.mobileNavOpenButton.classList.remove(this.ACTIVE_CLASS);
    this.mobileNavOpenButton.focus();
  }
}

export default MobileNav;
